import { IdentifierDecoratorSymbol, } from './dependencyIdentifier';
export function isCtor(thing) {
    return typeof thing === 'function';
}
export function isClassDependencyItem(thing) {
    if (thing && typeof thing.useClass !== 'undefined') {
        return true;
    }
    return false;
}
export function isFactoryDependencyItem(thing) {
    if (thing && typeof thing.useFactory !== 'undefined') {
        return true;
    }
    return false;
}
export function isValueDependencyItem(thing) {
    if (thing && typeof thing.useValue !== 'undefined') {
        return true;
    }
    return false;
}
export function isExistingDependencyItem(thing) {
    if (thing && typeof thing.useExisting !== 'undefined') {
        return true;
    }
    return false;
}
export function isAsyncDependencyItem(thing) {
    if (thing && typeof thing.useAsync !== 'undefined') {
        return true;
    }
    return false;
}
export var AsyncHookSymbol = Symbol('AsyncHook');
export function isAsyncHook(thing) {
    if (thing && thing.__symbol === AsyncHookSymbol) {
        // FIXME@wzhudev: should not be undefined but a symbol here
        return true;
    }
    return false;
}
export function prettyPrintIdentifier(id) {
    if (typeof id === 'undefined') {
        return 'undefined';
    }
    return isCtor(id) && !id[IdentifierDecoratorSymbol]
        ? id.name
        : id.toString();
}
//# sourceMappingURL=dependencyItem.js.map